import React, { useEffect, useState, useRef } from "react";
import {
  checkRFID,
  createOutbound,
  deleteOutbound,
  fetchAllOutboundByType,
} from "../../resources/OutboundResource";
import DataTable from "react-data-table-component";
import { format } from "date-fns";
import { fetchInboundByRFID } from "../../resources/InboundResource";
import { showSuccessToast } from "../../utils/GlobalToast";
import { getLocalAuth } from "../../utils/AuthUtils";
import { fetchAllUser } from "../../resources/UserResource";
import Select from "react-select";
import ErrorNotFound from "../errors/Error";
import axios from "axios";
import { baseUrl } from "../../constants/Constant";

function Outbound() {
  const values = getLocalAuth();
  const profile = JSON.parse(values.authLocal);
  const privilege = JSON.parse(values.authPrivilege);

  let dataPrivilege = privilege.data.menu.filter((data) => {
    return data.code === "Outbound";
  });

  let dataRead =
    dataPrivilege.length === 0
      ? []
      : dataPrivilege[0].action_page.filter((data) => {
        return data.code === "Read";
      });

  let dataCreate =
    dataPrivilege.length === 0
      ? []
      : dataPrivilege[0].action_page.filter((data) => {
        return data.code === "Create";
      });

  let dataDelete =
    dataPrivilege.length === 0
      ? []
      : dataPrivilege[0].action_page.filter((data) => {
        return data.code === "Delete";
      });

  const [dataUser, setDataUser] = useState([]);
  const [dataOutbound, setDataOutbound] = useState([]);
  const [dataPurpose] = useState([
    { name: "Routine Usage" },
    { name: "Investment" },
    { name: "Repair" },
    { name: "Trial/Event Kaizen" },
  ]);
  const [refreshKey, setRefreshKey] = useState(0);

  const [purpose, setPurpose] = useState("default");
  const [requestBy, setRequestBy] = useState("default");
  const [purposeView, setPurposeView] = useState("");
  const [requestByView, setRequestByView] = useState("");
  const [scanRequest, setScanRequest] = useState("");
  const [outboundItem, setOutboundItem] = useState([]);
  const [outboundItemView, setOutboundItemView] = useState([]);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [dateFilter, setDateFilter] = useState("");

  const [idEdit, setIdEdit] = useState(null);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [isErrorDelete, setIsErrorDelete] = useState(false);
  const [errorDelete, setErrorDelete] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const inputRef = useRef(null);

  const fetchOutbound = () => {
    fetchAllOutboundByType(
      1,
      dateFilter === "" ? "" : format(dateFilter, "yyyy-MM-dd").toString()
    )
      .then((res) => {
        setDataOutbound(res.data);
      })
      .catch((err) => {
        setDataOutbound([]);
      });
  };

  const fetchUser = () => {
    fetchAllUser()
      .then((res) => {
        setDataUser(res.data);
      })
      .catch((err) => {
        setDataUser([]);
      });
  };

  useEffect(() => {
    fetchUser();
    fetchOutbound();
    // eslint-disable-next-line
  }, [refreshKey]);

  let dataUserSelect = dataUser.map(function (data) {
    return { value: data.id, label: data.name };
  });

  const handleSubmit = () => {
    if (outboundItem.length === 0) {
      setError("You haven't done an RFID scan yet");
      setIsError(true);
    } else {
      postOutbound(
        purpose,
        profile.data.privilege_id !== 1 ? profile.data.id : requestBy,
        outboundItem
      );
    }
  };

  const postOutbound = (purpose, requestBy, outboundItem) => {
    setIsLoading(true);
    createOutbound(purpose, requestBy.value, outboundItem)
      .then((res) => {
        setIsLoading(false);
        setIsError(false);
        showSuccessToast("Success Added Outbound!");
        setShowAddModal(false);
        setScanRequest("");
        setRequestBy("default");
        setPurpose("default");
        setOutboundItem([]);
        fetchOutbound();
      })
      .catch((err) => {
        setIsLoading(false);
        setError(
          typeof err === "undefined"
            ? "There was an error checking your connection or input"
            : err
        );
        setIsError(true);
      });
  };

  const handleData = (data) => {
    setIdEdit(data.id);
    setPurposeView(data.purpose);
    setRequestByView(data.user === null ? "-" : data.user.name);
    setOutboundItemView(data.outbound_items);
  };

  const handleDelete = () => {
    setIsLoading(true);
    deleteOutbound(idEdit)
      .then((res) => {
        setIsLoading(false);
        setIsErrorDelete(false);
        showSuccessToast("Success Deleted Outbound!");
        setShowDeleteModal(false);
        fetchOutbound();
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorDelete(err);
        setIsErrorDelete(true);
      });
  };

  const fetchInbound = (scanRequest) => {
    if (!scanRequest) {
      setError("RFID cannot be empty!");
      setIsError(true);
      setScanRequest("");
    } else {
      checkRFID(scanRequest).then((res) => {
        // console.log(res);
        if (res?.result) {
          fetchInboundByRFID(scanRequest)
            .then((res) => {
              setScanRequest("");
              // console.log(res);

              if (!res.data) {
                setIsLoading(false);
                setError(`RFID: ${scanRequest} not yet in Inbound!`);
              } else {
                onSaveItem(
                  res.data.part.part_number,
                  res.data.rfid.rfid_number,
                  res.data.qty,
                  res.data.batch,
                  format(res.data.production_date, "yyyy-MM-dd").toString()
                );
              }
            })
            .catch((err) => {
              setScanRequest("");
              setIsLoading(false);
              setError(
                typeof err === "undefined"
                  ? `RFID: ${scanRequest} not yet register!`
                  : err
              );
              setIsError(true);
            });
        } else {
          setError(res?.message);
          setIsError(true);
          setScanRequest("");
        }
      });
    }
    // fetchInboundByRFID(scanRequest)
    //   .then((res) => {
    //     setScanRequest("");
    //     console.log(res);

    //     if (!res.data) {
    //       setIsLoading(false);
    //       setError(`RFID: ${scanRequest} not yet in Inbound!`);
    //     } else {
    //       onSaveItem(
    //         res.data.part.part_number,
    //         res.data.rfid.rfid_number,
    //         res.data.qty,
    //         res.data.batch,
    //         format(res.data.production_date, "yyyy-MM-dd").toString()
    //       );
    //     }
    //   })
    //   .catch((err) => {
    //     setScanRequest("");
    //     setIsLoading(false);
    //     setError(
    //       typeof err === "undefined"
    //         ? `RFID: ${scanRequest} not yet register!`
    //         : err
    //     );
    //     setIsError(true);
    //   });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      // console.log(scanRequest);
      fetchInbound(scanRequest);
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 200);
    }
  };

  const onChangeScanRequestAdd = (e) => {
    setScanRequest(e.target.value);
  };

  const onSaveItem = (part, rfid, qty, batch, productionDate) => {
    let filteredItems = outboundItem.filter((item) => {
      // eslint-disable-next-line
      return item.rfid == rfid;
    });
    if (filteredItems.length >= 1) {
      setIsError(true);
      setError(`RFID: ${scanRequest} has been added!`);
    } else {
      setOutboundItem([
        ...outboundItem,
        {
          part: part,
          rfid: rfid,
          qty: qty,
          batch: batch,
          production_date: productionDate,
        },
      ]);
    }
  };

  const onChangeHandlerRequestBy = (options) => {
    setRequestBy(options);
  };

  const columnsRequestView = [
    {
      name: "Part",
      selector: (row) => row.part.part_number,
      width: "180px",
    },
    {
      name: "Batch",
      selector: (row) => row.batch,
      width: "180px",
    },
    {
      name: "QTY",
      selector: (row) => row.qty,
      width: "80px",
    },
    {
      name: "RFID",
      selector: (row) =>
        row.outbound_item_outs.map((data) => {
          return (
            <div key={data.id}>
              {data.rfid === null ? "-" : data.rfid.rfid_number}
            </div>
          );
        }),
    },
    {
      name: "QTY",
      selector: (row) =>
        row.outbound_item_outs.map((data) => {
          return <div key={data.id}>{data.qty}</div>;
        }),
      width: "80px",
    },
    {
      name: "Production Date",
      selector: (row) =>
        row.outbound_item_outs.map((data) => {
          return (
            <div key={data.id}>
              {data.production_date === null
                ? "-"
                : format(data.production_date, "yyyy-MM-dd").toString()}
            </div>
          );
        }),
      width: "150px",
    },
  ];

  const columnsRequest = [
    {
      name: "Part",
      selector: (row) => row.part,
    },
    {
      name: "Batch",
      selector: (row) => row.batch,
    },
    {
      name: "QTY",
      selector: (row) => row.qty,
      width: "80px",
    },
    {
      name: "RFID",
      selector: (row) => row.rfid,
      width: "250px",
    },
    {
      name: "Actions",
      width: "90px",
      cell: (row) => (
        <>
          <button
            type="button"
            style={{ marginRight: "8px" }}
            className="btn btn-danger"
            onClick={() =>
              setOutboundItem(outboundItem.filter((a) => a.rfid !== row.rfid))
            }
          >
            <i className="bx bx-trash"></i>
          </button>
        </>
      ),
    },
  ];

  const onChangeHandler = (e) => {
    const index = e.target.selectedIndex;
    const el = e.target.childNodes[index];
    const option = el.getAttribute("name");
    setPurpose(option);
  };

  const columns = [
    {
      name: "No",
      cell: (row, index) => index + 1,
      width: "60px",
    },
    // {
    //   name: "Request By",
    //   selector: (row) => (row.user === null ? "-" : row.user.name),
    //   sortable: true,
    // },
    // {
    //   name: "Purpose",
    //   selector: (row) => row.purpose,
    //   sortable: true,
    // },
    {
      name: "Part No",
      selector: (row) =>
        row.outbound_items.map((data) => {
          return (
            <div key={data.id}>{`${data.part === null
                ? "-"
                : data.part.part_number === null
                  ? "-"
                  : data.part.part_number
              }`}</div>
          );
        }),
      sortable: true,
    },
    {
      name: "Part Name",
      selector: (row) =>
        row.outbound_items.map((data) => {
          return (
            <div key={data.id}>{`${data.part === null
                ? "-"
                : data.part.name === null
                  ? "-"
                  : data.part.name
              }`}</div>
          );
        }),
      sortable: true,
    },
    {
      name: "Batch",
      selector: (row) =>
        row.outbound_items.map((data) => {
          return (
            <div key={data.id}>{`${data.part === null
                ? "-"
                : data.part.batch === null
                  ? "-"
                  : data.part.batch
              }`}</div>
          );
        }),
      sortable: true,
    },
    {
      name: "QTY",
      selector: (row) =>
        row.outbound_items.map((data) => {
          return <div key={data.id}>{`${data.qty}`}</div>;
        }),
      sortable: true,
    },
    {
      name: "RFID Name",
      selector: (row) =>
        row.outbound_items.map((data) => {
          return data.outbound_item_outs.map((data) => {
            return (
              <div key={data.id}>
                {data.rfid === null ? "-" : data.rfid.name}
              </div>
            );
          });
        }),
      sortable: true,
    },
    {
      name: "Scan Date",
      selector: (row) =>
        format(row.datetime_scan, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
      width: "180px",
    },
    {
      name: "Progress",
      selector: (row) =>
        row.progress === null ? (
          "-"
        ) : row.progress <= 50 ? (
          <a
            href="#section"
            className="btn btn-sm btn-light-info btn-block radius-30"
          >
            {`${row.progress}%`}
          </a>
        ) : row.progress >= 51 && row.progress <= 99 ? (
          <a
            href="#section"
            className="btn btn-sm btn-light-warning btn-block radius-30"
          >
            {`${row.progress}%`}
          </a>
        ) : (
          <a
            href="#section"
            className="btn btn-sm btn-light-success btn-block radius-30"
          >
            {`${row.progress}%`}
          </a>
        ),
      sortable: true,
    },
    {
      name: "Scanned By",
      selector: (row) => row?.user?.name,
      sortable: true,
      width: "150px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          {dataDelete.length === 0 ? (
            <div></div>
          ) : !dataDelete[0].is_active ? (
            <div></div>
          ) : (
            <button
              type="button"
              style={{ marginRight: "8px" }}
              className="btn btn-danger"
              onClick={() => {
                handleData(row);
                setShowDeleteModal(true);
              }}
            >
              Delete
            </button>
          )}
          <div
            className={`modal fade ${showDeleteModal ? "show" : ""}`}
            style={{
              display: showDeleteModal ? "block" : "none",
              backgroundColor: "rgba(0, 0, 0, 0.1)",
            }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Delete this data?</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowDeleteModal(false)}
                    aria-label="Close"
                  ></button>
                </div>
                {isErrorDelete ? (
                  <div
                    style={{
                      paddingLeft: "16px",
                      paddingRight: "16px",
                      paddingTop: "16px",
                      paddingBottom: "0px",
                    }}
                  >
                    <div
                      className="alert alert-danger alert-dismissible fade show"
                      role="alert"
                    >
                      {errorDelete}
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="alert"
                        aria-label="Close"
                        onClick={() => setIsErrorDelete(false)}
                      ></button>
                    </div>
                  </div>
                ) : null}
                <div className="modal-body">You will delete this Outbound</div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    Cancel
                  </button>
                  {!isLoading ? (
                    <button
                      type="submit"
                      className="btn btn-danger"
                      onClick={() => handleDelete()}
                    >
                      Delete
                    </button>
                  ) : (
                    <button className="btn btn-danger" type="button" disabled>
                      {" "}
                      <span
                        style={{ marginRight: "4px" }}
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Loading...
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <button
            type="button"
            style={{ marginRight: "8px" }}
            className="btn btn-info"
            data-bs-toggle="modal"
            data-bs-target="#viewModal"
            onClick={() => handleData(row)}
          >
            View
          </button>
          <div className="modal fade" id="viewModal" aria-hidden="true">
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Detail Outbound</h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                    {/* <div className="mb-3">
                      <div className="row">
                        <div className="col">
                          <label className="form-label fw-bold">
                            User Request
                          </label>
                          <input
                            required
                            disabled
                            type="text"
                            className="form-control"
                            value={requestByView}
                            onChange={(e) => setRequestByView(e.target.value)}
                          />
                        </div>
                        <div className="col">
                          <label className="form-label fw-bold">Purpose</label>
                          <input
                            required
                            disabled
                            type="text"
                            className="form-control"
                            value={purposeView}
                            onChange={(e) => setPurposeView(e.target.value)}
                          />
                        </div>
                      </div>
                    </div> */}
                    <div className="mb-3">
                      <label className="form-label fw-bold">List Request</label>
                      <DataTable
                        columns={columnsRequestView}
                        data={outboundItemView}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];

  // Download to Excel
  const handleDownload = () => {
    axios({
      url: `${baseUrl}/outbound/download`, // replace with the actual file URL
      method: "GET",
      responseType: "blob", // important
      headers: { Authorization: `Bearer ${profile.data.token}` },
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Master Outbound.xlsx"); // replace with the desired file name
        document.body.appendChild(link);
        link.click();
        // message.success("File has been downloaded!");
        console.log("File has been downloaded!");
      })
      .catch((error) => {
        // message.info("Error downloading file!");
        console.error("Error downloading file:", error);
      });
  };

  return (
    <div>
      {dataRead.length === 0 ? (
        <ErrorNotFound />
      ) : !dataRead[0].is_active ? (
        <ErrorNotFound />
      ) : (
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="card">
              <div className="card-body">
                <div className="card-title">
                  <div className="row">
                    <div className="col-md-8">
                      <h4 className="mb-0">Outbound</h4>
                    </div>
                    <div
                      className="col-md-4"
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <button
                        type="button"
                        style={{ margin: 0 }}
                        className="btn btn-info radius-10"
                        onClick={handleDownload}
                      >
                        <i class="bx bx-file"></i>Download
                      </button>
                      {dataCreate.length === 0 ? (
                        <div></div>
                      ) : !dataCreate[0].is_active ? (
                        <div></div>
                      ) : (
                        <button
                          type="button"
                          style={{ margin: 0 }}
                          className="btn btn-info radius-10"
                          onClick={() => {
                            setShowAddModal(true);
                            setTimeout(() => {
                              if (inputRef.current) {
                                inputRef.current.focus();
                              }
                            }, 200);
                          }}
                        >
                          <i className="bx bx-plus"></i> Outbound
                        </button>
                      )}
                    </div>
                    <div
                      className={`modal fade ${showAddModal ? "show" : ""}`}
                      style={{
                        display: showAddModal ? "block" : "none",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                      }}
                    >
                      <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Outbound</h5>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => {
                                setShowAddModal(false);
                              }}
                              aria-label="Close"
                            ></button>
                          </div>
                          {isError ? (
                            <div
                              style={{
                                paddingLeft: "16px",
                                paddingRight: "16px",
                                paddingTop: "16px",
                                paddingBottom: "0px",
                              }}
                            >
                              <div
                                className="alert alert-danger alert-dismissible fade show"
                                role="alert"
                              >
                                {error}
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="alert"
                                  aria-label="Close"
                                  onClick={() => setIsError(false)}
                                ></button>
                              </div>
                            </div>
                          ) : null}
                          <div className="modal-body">
                            <form>
                              <div className="mb-3">
                                <label className="form-label fw-bold">
                                  RFID
                                </label>
                                <input
                                  autoFocus
                                  ref={inputRef}
                                  type="text"
                                  className="form-control"
                                  value={scanRequest}
                                  onKeyDown={handleKeyDown}
                                  onChange={onChangeScanRequestAdd}
                                  placeholder="Scan Here"
                                />
                              </div>
                              {/* <div className="mb-3">
                                <div className="row">
                                  <div className="col">
                                    <label className="form-label fw-bold">User Request</label>
                                    {profile.data.privilege_id !== 1 ? <input type="text" className="form-control" value={profile.data.name} disabled /> : <Select
                                      value={requestBy}
                                      onChange={onChangeHandlerRequestBy}
                                      options={dataUserSelect}
                                    />}
                                  </div>
                                  <div className="col">
                                    <label className="form-label fw-bold">Purpose</label>
                                    <select className="form-select mb-3" aria-label="Default select example"
                                      value={purpose}
                                      onChange={onChangeHandler}>
                                      <option value="default" disabled>Select Purpose</option>
                                      {
                                        dataPurpose.map((data) => {
                                          return (<option id={data.name}
                                            name={data.name}
                                            key={data.name}
                                            value={data.name}>{data.name}</option>);
                                        })
                                      }
                                    </select>
                                  </div>
                                </div>
                              </div> */}
                              <div className="mb-3">
                                <label className="form-label fw-bold">
                                  List Request
                                </label>
                                <div className="mb-1 mt-1">
                                  <div
                                    style={{
                                      width: "200px",
                                      color: "#FFF",
                                      backgroundColor: "#32ab13",
                                      borderRadius: "8px",
                                      paddingLeft: "16px",
                                      paddingRight: "16px",
                                      paddingBottom: "8px",
                                      paddingTop: "8px",
                                      textAlign: "center",
                                    }}
                                  >{`${outboundItem.length} Scanned`}</div>
                                </div>
                                <DataTable
                                  columns={columnsRequest}
                                  data={outboundItem}
                                />
                              </div>
                              <br></br>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  onClick={() => {
                                    setShowAddModal(false);
                                  }}
                                >
                                  Cancel
                                </button>
                                {!isLoading ? (
                                  <button
                                    type="button"
                                    className="btn btn-info"
                                    onClick={() => handleSubmit()}
                                  >
                                    Submit
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn-info"
                                    type="button"
                                    disabled
                                  >
                                    {" "}
                                    <span
                                      style={{ marginRight: "4px" }}
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    Loading...
                                  </button>
                                )}
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-3">
                    <label className="form-label">Scan Date:</label>
                    <input
                      type="date"
                      className="form-control"
                      value={dateFilter}
                      onChange={(e) => {
                        setDateFilter(e.target.value);
                        setRefreshKey((refreshKey) => refreshKey + 1);
                      }}
                    />
                  </div>
                </div>
                <br />
                <div className="table-responsive">
                  <DataTable columns={columns} data={dataOutbound} pagination />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Outbound;
